module.exports = __webpack_public_path__ + "img/vertical_3_6_5.51f3789a.png";